/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-ugc-用户投稿
 */
'use strict';
angular.module('userContributionModule', ['userContributionDetailsRouter']).controller('userContributionCtrl', [
    '$scope',
    'httpService',
    '$filter',
    'modalDialog',
    '$q',
    function ($scope, httpService, $filter, modalDialog, $q) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.status = {
                inputData: '',
                firstClassOptions: [],
                selectedFirstClass: '',
                secondClassOptions: [],
                selectedSecondClass: '',
                theDocTypeOptions: [
                    {
                        name: '全部类型',
                        value: '-1'
                    },
                    {
                        name: '新闻',
                        value: '0'
                    },
                    {
                        name: '视频',
                        value: '2'
                    },
                    {
                        name: '图集',
                        value: '3'
                    }
                ],
                theDocType: {
                    name: '全部类型',
                    value: '-1'
                }
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0
            };
            $scope.data = {
                articleTypes: {
                    0: '新闻',
                    2: '视频',
                    3: '图集'
                },
                listData: [],
                keywords: '', //检索的关键词
                selectedArray: [] //选中的数据
            };
            $scope.params = {
                startTime: '',
                endTime: '',
                searchWord: ''
            };
            initDropDownList();
        }

        function initData() {
            initFristClassifiy().then(function () {
                initSecondClassifiy().then(function () {
                    requestData();
                });
            });
        }
        /**
         * [initDropDownList description] 初始化下拉菜单
         * @return {[type]} [description]
         */
        /**
         * [initDropDownList description] 初始化下拉菜单
         * @return {[type]} [description]
         */
        function initDropDownList() {
            $scope.status.manuscriptOptions = [
                {
                    name: '稿件状态',
                    value: ''
                },
                {
                    name: '未发布',
                    value: 0
                },
                {
                    name: '已发布',
                    value: 1
                }
            ];
            $scope.status.selectedManuscript = angular.copy($scope.status.manuscriptOptions[0]);

            $scope.status.royaltiesOptions = [
                {
                    name: '稿费状态',
                    value: ''
                },
                {
                    name: '未发稿费',
                    value: 0
                },
                {
                    name: '已发稿费',
                    value: 1
                }
            ];
            $scope.status.selectedRoyalties = angular.copy($scope.status.royaltiesOptions[0]);
        }

        /**
         * [initFristClassifiy description] 加载一级分类
         * @return {[type]} [description]
         */
        function initFristClassifiy() {
            var deffer = $q.defer();
            httpService.http('/mcnadmin/admin/classic/queryClassics.do', '', 'post').then(function (data) {
                var item = data.data;
                var allchannel = {
                    name: '一级分类',
                    value: ''
                };
                $scope.status.firstClassOptions.push(allchannel);
                for (var i = 0; i < item.length; i++) {
                    var creatJSON = {};
                    creatJSON.name = item[i].departName;
                    creatJSON.value = item[i].id;
                    $scope.status.firstClassOptions.push(creatJSON);
                }
                $scope.status.selectedFirstClass = angular.copy($scope.status.firstClassOptions[0]);
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [initSecondClassifiy description] 加载二级分类
         * @return {[type]} [description]
         */
        function initSecondClassifiy() {
            $scope.status.secondClassOptions = [];
            var deffer = $q.defer();
            var fid = $scope.status.firstClassId;
            var allchannel = {
                name: '二级分类',
                value: ''
            };
            $scope.status.secondClassOptions.push(allchannel);
            if ($scope.status.selectedFirstClass.value != '') {
                var params = {
                    id: $scope.status.selectedFirstClass.value
                };
                httpService.http('/mcnadmin/admin/classic/queryClassics.do', params, 'post').then(function (data) {
                    var item = data.data;
                    for (var i = 0; i < item.length; i++) {
                        var creatJSON = {};
                        creatJSON.name = item[i].departName;
                        creatJSON.value = item[i].id;
                        $scope.status.secondClassOptions.push(creatJSON);
                    }
                });
            }
            deffer.resolve();
            $scope.status.selectedSecondClass = angular.copy($scope.status.secondClassOptions[0]);
            return deffer.promise;
        }
        /**
         * [initTwoclass description] 加载二级分类
         * @return {[type]} [description]
         */
        $scope.initTwoclass = function () {
            initSecondClassifiy().then(function () {
                requestData();
            });
        };
        /**
         * [requestData description] 初始数据
         * @return {[type]} [description]
         */
        $scope.requestData = function () {
            requestData();
        };

        function requestData() {
            $scope.data.selectedArray = [];
            var params = {
                firstClassId: $scope.status.selectedFirstClass.value,
                secondClassId: $scope.status.selectedSecondClass.value,
                articleUseStatus: $scope.status.selectedManuscript.value,
                articleCostStatus: $scope.status.selectedRoyalties.value,
                startTime: $scope.params.startTime,
                endTime: $scope.params.endTime,
                articleType: $scope.status.theDocType.value,
                searchWord: $scope.params.searchWord,
                searchTime: '',
                currPage: $scope.page.CURRPAGE,
                pageSize: $scope.page.PAGESIZE
            };
            $scope.loadingPromise = httpService.http('/mcnadmin/admin/article/articleList.do', params, 'post').then(function (data) {
                var list = data.data.ldata;
                angular.forEach(list, function (data) {
                    if (data.articlePublishDept) {
                        data.articlePublishDept = data.articlePublishDept
                            .substring(1, data.articlePublishDept.length - 1)
                            .replace(/\"/g, '')
                            .split(',')
                            .join(' - ');
                    } else {
                        data.articlePublishDept = '-';
                    }
                });
                $scope.data.listData = list;
                $scope.page = {
                    CURRPAGE: data.data.startPage,
                    PAGESIZE: data.data.pageSize,
                    ITEMCOUNT: data.data.totalResults,
                    PAGECOUNT: data.data.totalPages
                };
            });
        }
        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function () {
            $scope.params.startTime = $scope.status.startDate;
            $scope.params.endTime = $scope.status.endDate;
            requestData();
        };
        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下回车也能提交]
         */
        $scope.fullTextSearch = function (ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.searchWord = $scope.data.keywords;
                requestData();
            }
        };
        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 当前数据
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
        };
        /**
         * [selectPanel description] 全选当前面板的稿件
         * @param  {[type]} items [description] 当前面板
         * @return {[type]}       [description]
         */
        $scope.selectPanel = function (items) {
            if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.listData);
            }
        };
        /**
         * [dateFormat description] 时间格式化
         * @return {[type]} [description]
         */
        $scope.dateFormat = function (time) {
            return $filter('date')(time, 'yyyy-MM-dd HH:mm:ss').toString();
        };
        /**
         * [export description]导出
         * @return {[type]} [description]
         */
        $scope.export = function () {
            var o = $scope.status;
            var ids = angular.packageIds($scope.data.selectedArray, ',', 'id');
            var firstClassId = o.selectedFirstClass.value;
            var secondClassId = o.selectedSecondClass.value;
            var articleUseStatus = o.selectedManuscript.value;
            var articleType = $scope.status.theDocType.value;
            var articleCostStatus = o.selectedRoyalties.value;
            var startTime = o.startDate || '';
            var endTime = o.endDate || '';
            var params = 'ids=' + ids + '&firstClassId=' + firstClassId + '&secondClassId=' + secondClassId + '&articleUseStatus=' + articleUseStatus + '&articleCostStatus=' + articleCostStatus + '&articleType=' + articleType + '&startTime=' + startTime + '&endTime=' + endTime;
            var url = '/mcnadmin/admin/article/ExportExcel.do?' + params;

            modalDialog.backConfirmModal('导出', '确认导出所有稿件？', function () {
                // window.open(url);
                var $a = $(document.createElement('a'));
                $a.attr({
                    href: url,
                    download: 'UGC稿件列表'
                });
                $a[0].click();
            });
        };
    }
]);
